export type PaginationModel = {
  totalRecords: number,
  currentPage: number,
  pageSize: number,

  onPageChange: (page: number) => void
}

export default function Pagination({ totalRecords, currentPage, pageSize, onPageChange }: PaginationModel) {
  const totalPages = Math.ceil(totalRecords/pageSize);

  let pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(<a key={`page-${i}`} className={'page' + (currentPage === i ? ' active' : '')} 
      onClick={() => onPageChange(i)}><span>{i}</span></a>)
  }

  return (
    <>    
    { pages.length > 1  && 
      <div className="pagination-page-links">
        <a className={`shifter ${currentPage == 1 ? 'disabled' : ''}`} onClick={() => onPageChange(1)}><span className="fa fa-angle-left" aria-hidden="true"></span></a>
        <ul>
          <li>
          {pages}
          </li>
        </ul>
        <a className={`shifter ${currentPage == totalPages ? 'disabled' : ''}`} onClick={() => onPageChange(totalPages)}><span className="fa fa-angle-right" aria-hidden="true"></span></a>
      </div>
    }
    </>
  )
}